import { CompanyCategory } from '../state/slices/companies_slice'
import { BaseUrl } from './base_url_enum'
import Api from './index'
import { IRepairer } from './types/company'
import { IApiResponse } from './index'

export const getClaimCompanyData = () =>
  Api<IApiResponse<{
    categories: CompanyCategory[]
    radius: number[]
  }>>('GET', 'v2/claim-company-data', BaseUrl.Claim)

export const searchClaimCompanies = (params: {
  q: string
  radius: number
  category_id: number
  brand_id: number | null
}) =>
  Api<IApiResponse<{
    claimCompanies: IRepairer[]
    citySelect: any[]
  }>>('POST', 'v2/claim-company-search', BaseUrl.Claim, params)
